export default {
    pullingText: '下拉即可刷新...',
    loosingText: '释放即可刷新...',
    loadingText: '加载中...',
    errorName: '错误名称',
    illustration: '图示',
    errorCode: '错误代码',
    loadMore: '加载更多',
    emptyTxt: '暂无数据'
}
